import React from 'react';
import GetStationsQuery from './GetStationsQuery';

// eslint-disable-next-line react/display-name
const withStations = (Component) => (props) =>
  <GetStationsQuery>{({ stations }) => <Component stations={stations} {...props} />}</GetStationsQuery>;

export default withStations;
